import { AppInstallQuickLinkType } from "src/website-apps/shared/utils/getAppInstallQuickLinkUrl";
import type { AppInstallInterstitialPlacement } from "./types";

/**
 * Maps an interstitial placement to the corresponding AppInstallQuickLinkType
 * used when generating App Store / Google Play deep links.
 */
export const placementToLinkType = (placement: AppInstallInterstitialPlacement): number =>
  placement === "performer" ? AppInstallQuickLinkType.PERFORMER : AppInstallQuickLinkType.HOME;
